export const ROUTES = {
  PUBLIC: {
    HOME: "home",
    CONTACT_US: "contact-us",
    SETTINGS: "settings",
    SUBSCRIPTIONS: "Subscriptions",
    BLOCKCHAIN_EXPLORER: "blockchain-explorer/:hashid"
  },
  AUTH: {
    REDIRECTING: "/elystrion/redirecting",
  },
  TENANT: {
    HOME: "home",
    DASHBOARD: "dashboard",
    USER_MANAGEMENT: "user-management",
    COMPANIES: "companies",
    PRODUCTS: "products",
    PRODUCTS_TENANT: "products/:tenantid",
    PRODUCT_DETAIL: "products/detail/:productId",
    PRODUCT_TYPES: "product-types",
    PRODUCT_DESIGN: "product-design",
    BLOCKCHAIN_EXPLORER: "blockchain-explorer/:hashid",
    APPROVALS: "approvals",
    DETAIL_FORM: "detail-form",
    PRODUCT_CATEGORY: "product-category",
  }
};
